import script from "./WorkspaceNameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceNameCell.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceNameCell.vue?vue&type=style&index=0&id=36bb0845&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bb0845"]])

export default __exports__